import { Component, OnInit } from '@angular/core';
import { patronage } from "src/app/models/dashboard/patronage";
import { CardModule } from 'primeng/card';
import { TreeNode } from 'primeng/api';
import { DataService } from "src/app/services/data.service";
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-patronage',
  templateUrl: './patronage.component.html',
  styleUrls: ['./patronage.component.scss']
})
export class PatronageComponent implements OnInit {
  public showHistoricalDetails: boolean = false;
  public hasData: boolean = false;



  paymentOptions = [
    { label: 'ACH', value: 'ACH' },
    { label: 'Check', value: 'Check' } 
  ];

  valSelect1: string;
  mode: 'Rebate' | 'Patronage' = 'Patronage'; // default mode, can be changed elsewhere

  public investment: patronage = new patronage();

  public historicalInvestment: patronage = {
    accountID: 1002,
    totalValue: 25120.84,
    perc: 0.6,
    shares: 140,
    balance: 23094.85,
    profit: 2625.66,
    dividend: 2625.66,
    payment: 1050.26,
    credit: 1575.40,
    dateLoaded: 20230101,
    batchID: 2022,
    stockValue: 90,
    taxWithholding: 89,
    withdrawl: 0,
    endingRetention: 32
  };

  yearOptions = [
    { label: '2024', value: 2024 },
    { label: '2023', value: 2023 },
    { label: '2022', value: 2022 },
  ];

  public selectedYear: number;

  constructor(private dataService: DataService, private messageService: MessageService) { }

  ngOnInit(): void {

    this.loadInitialPaymentMethod();

    this.dataService.getPatronageYears().subscribe(years => {
      this.yearOptions = years.map(year => ({
        label: year.toString(),
        value: year
      }));

      if (this.yearOptions.length > 0) {
        const defaultYear = this.yearOptions[0].value;
        this.selectedYear = defaultYear;
        this.loadPatronageData(defaultYear);
      }
    });
  }

  showTestToast() {
    this.messageService.add({
      severity: 'info',
      summary: 'Test',
      detail: 'Toast is working'
    });
  }

  loadPatronageData(year: number) {
    this.selectedYear = year;
    this.dataService.getPatronage(year).subscribe(data => {

      this.investment = new patronage(data);

      // Check if any investment data is present
      this.hasData = !!data && (
        data.totalValue > 0 ||
        data.balance > 0 ||
        data.dividend > 0 ||
        data.shares > 0
      );
    }, error => {
      this.hasData = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Data Error',
        detail: 'Unable to load patronage data.'
      });


    });
  }



  loadInitialPaymentMethod() {
    this.dataService.getPatronagePaymentMethod(this.mode).subscribe({
      next: (res) => {
        console.log('Initial Payment Method:', res.method);
        this.valSelect1 = res.method;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to Load',
          detail: err.error?.error || 'Unable to fetch payment method.'
        });
      }
    });
  }


  onOptionSelected() {
    this.dataService.UpdateQuarterlyPaymentMethod(this.valSelect1, this.mode).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Payment Method Updated',
        detail: `Your ${this.mode} payment method was set to "${this.valSelect1}".`
      });
    });
  }

  onYearChanged(event: any) {
    this.selectedYear = event; // safe extraction
    this.loadPatronageData(this.selectedYear);
  }

}
